import * as Utils from 'Assets/Utils'

import Immutable from 'immutable'
import ClientHttpRequest from "Api/ClientHttpRequest"
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
	.set('Get', new Immutable.Map({evaluacionVariable: {resultadosVariable: {resultadoVariable: []}}}))
	.set('Search', new Immutable.Map({evaluacionVariable: {resultadosVariable: {resultadoVariable: []}}}))
	.set('get_retroalimentacion', new Immutable.Map({}))
	.set('get_rango_tipo_evaluacion', new Immutable.Map({}))
	.set('get_rango_tipo_evaluacion_todo', new Immutable.Map({}))
	.set('get_resultado_evaluacion', new Immutable.Map({}))

/* Types */
export const GET_RESULTS = 'GET_RESULTS'
export const GET_VARIABLE_RESULTS = 'GET_VARIABLE_RESULTS'
export const GET_RETROALIMENTACION = 'GET_RETROALIMENTACION'
export const GET_RANGO_TIPO_EVALUACION = 'GET_RANGO_TIPO_EVALUACION'
export const GET_RANGO_TIPO_EVALUACION_TODO = 'GET_RANGO_TIPO_EVALUACION_TODO'
export const GET_RESULTADO_EVALUACION = 'GET_RESULTADO_EVALUACION'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_VARIABLE_RESULTS:
			return state.set('Search', new Immutable.Map(action.Obj))
		case GET_RESULTS:
			return state.set('Get', new Immutable.Map(action.Obj))
		case GET_RETROALIMENTACION:
			return state.set('get_retroalimentacion', new Immutable.Map(action.Obj))
		case GET_RANGO_TIPO_EVALUACION:
			return state.set('get_rango_tipo_evaluacion', new Immutable.Map(action.Obj))
		case GET_RANGO_TIPO_EVALUACION_TODO:
			return state.set('get_rango_tipo_evaluacion_todo', new Immutable.Map(action.Obj))
		case GET_RESULTADO_EVALUACION:
			return state.set('get_resultado_evaluacion', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const getResults = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getResults',
			method: "POST",
			data: { ...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			response.data.uniqueId = Utils.getUUID()
			dispatch({ type: GET_RESULTS, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const setResults = (form) => {

	let {idEvaluacion, resultadoVariable} = form

	resultadoVariable = resultadoVariable.map((r) => {
		delete r.retroalimentacionCatalogo
		delete r.retroArray
		return {...r}
	})

	let temp = {
		evaluacionVariable: {
			idEvaluacion,
			resultadosVariable: {
				resultadoVariable
			}
		}
	}

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/setResults',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			dispatch({ type: GET_VARIABLE_RESULTS, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const getVariableResults = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getVariableResults',
			method: "POST",
			data: { ...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			response.data.uniqueId = Utils.getUUID()
			dispatch({ type: GET_VARIABLE_RESULTS, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const clearResults = () => {
	return (dispatch) => {
		dispatch({ type: GET_RESULTS, Obj: {evaluacionVariable: {resultadosVariable: {resultadoVariable: []}}} })
	}
}

export const clearVariableResults = () => {
	return (dispatch) => {
		dispatch({ type: GET_VARIABLE_RESULTS, Obj: {evaluacionVariable: {resultadosVariable: {resultadoVariable: []}}} })
	}
}

export const getRetroAlimentacion = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getRetroAlimentacion',
			method: "POST",
			data: { ...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			response.data.uniqueId = Utils.getUUID()
			dispatch({ type: GET_RETROALIMENTACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const getRangoTipoEvaluacion = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getRangoTipoEvaluacion',
			method: "POST",
			data: { ...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			response.data.uniqueId = Utils.getUUID()
			dispatch({ type: GET_RANGO_TIPO_EVALUACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const getRangoTipoEvaluacionTodo = () => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getRangoTipoEvaluacionTodo',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			response.data.uniqueId = Utils.getUUID()
			dispatch({ type: GET_RANGO_TIPO_EVALUACION_TODO, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const getResultadosEvaluacion = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getResultadosEvaluacion',
			method: "POST",
			data: { ...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			response.data.uniqueId = Utils.getUUID()
			dispatch({ type: GET_RESULTADO_EVALUACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Evaluation/Results.js